import { GiMeat } from "react-icons/gi";
import { MdSevereCold } from "react-icons/md";
import { GiRoastChicken } from "react-icons/gi";
import { LiaCheeseSolid } from "react-icons/lia";
import { TiShoppingCart } from "react-icons/ti";
import { GiBellPepper } from "react-icons/gi";
import { PiBasketBold } from "react-icons/pi";

import {Category} from '../../types/category';

import {categories} from '../../data/categories';

const categoriesIcon = {
  [Category.Carnes]: GiMeat,
  [Category.Congelados]: MdSevereCold,
  [Category.Aves]: GiRoastChicken,
  [Category.Frios]: LiaCheeseSolid,
  [Category.Mercearia]: TiShoppingCart,
  [Category.Temperos]: GiBellPepper,
  [Category.Kits]: PiBasketBold,
};

export const CategoryMenu = () => {
  const handleScrollToCategorySection = (category: Category) => (e: React.MouseEvent) => {
    e.preventDefault();

    const section = document.getElementById(`${category}-products-section`)!;

    window.scrollTo({
      behavior: 'smooth',
      top: section.offsetTop - 120,
    });
  };

  return (
    <nav className="flex gap2 box-content overflow-x-auto sticky top-16 left-0 bg-white">
      {categories.map(category => {
        const Icon = categoriesIcon[category.type];

        return (
          <a
            href="#"
            key={`category-menu-item-${category.type}`}
            className="flex py-4 px-4 border-solid border-r border-r-gray-200 gap-1 items-center hover:bg-gray-100"
            onClick={handleScrollToCategorySection(category.type)}
          >
            <Icon className="text-2xl" />
            <span className="text-sm text-gray-600">{category.text}</span>
          </a>
        );
      })}
    </nav>
  );
};
